<template>
    <div id="app">
        <HelloWorld msg="Welcome to Your Vue.js App"/>
    </div>
</template>

<script>

import HelloWorld from './components/HelloWorld.vue'

export default {
    name: 'App',
    components: {
        HelloWorld
    }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin:-8px -8px -8px -8px;
    background-color:#000;
    height: 100vh;;
}

</style>
